import { Table } from '@mantine/core'
import { Collapse } from '@shared/components/collapse/collapse'
import { useState } from 'react'
import classes from '@/components/speci/speci-sidebar-table.module.css'
import { ContractDetail } from '@shared/loom-api/.generated/types'

export interface StationContractsTableProps {
  heading?: string
  contracts?: ContractDetail[]
}

export function StationContractsTable({
  heading = 'Station Contracts',
  contracts = [],
}: StationContractsTableProps) {
  const [isOpen, setIsOpen] = useState(false)
  const rows = contracts.map((contract) => (
    <Table.Tr key={contract.contractName}>
      <Table.Td>{contract.contractName}</Table.Td>
      <Table.Td>{contract.purchaseAccountRecordNumber}</Table.Td>
      <Table.Td className={classes.rightAlign}>{contract.contracted}</Table.Td>
      <Table.Td className={classes.rightAlign}>{contract.outstanding}</Table.Td>
    </Table.Tr>
  ))

  return (
    <Collapse
      sectionHeading={heading}
      buttonLabel='table'
      isOpen={isOpen}
      toggle={() => setIsOpen(!isOpen)}
    >
      <Table.ScrollContainer minWidth={400}>
        <div className={classes.tableContainer}>
          <Table withColumnBorders>
            <Table.Thead>
              <Table.Tr>
                <Table.Th>Contract Name</Table.Th>
                <Table.Th>Contract Reference</Table.Th>
                <Table.Th className={classes.rightAlign}>Bales Contracted</Table.Th>
                <Table.Th className={classes.rightAlign}>Bales Outstanding</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>{rows}</Table.Tbody>
          </Table>
        </div>
      </Table.ScrollContainer>
    </Collapse>
  )
}
